<div class="space-y-6" [formGroup]="form()">
  <div class="grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
    <ui-input
      [control]="form().controls.landRatePsf"
      label="Circled Land Rate"
      type="number"
      prefix="₹"
      suffix="/sq.ft"
      placeholder="9500"
      [required]="true"
      hint="Supply Team's maintained rate for this location."
    />

    <ui-select
      [control]="form().controls.zoning"
      label="Zoning"
      [options]="zoningOptions"
    />

    <ui-input
      [control]="form().controls.roadWidthFt"
      label="Road Width"
      type="number"
      suffix="ft"
      placeholder="40"
    />

    <!-- <ui-input
      [control]="form().controls.frontageFt"
      label="Frontage"
      type="number"
      suffix="ft"
      placeholder="40"
    /> -->

    <div class="flex items-end pb-1">
      <label class="flex cursor-pointer items-center gap-2.5 text-sm text-slate-700">
        <input
          type="checkbox"
          formControlName="cornerPlot"
          class="size-4 rounded border-slate-300 accent-indigo-600"
        />
        Corner plot
      </label>
    </div>
  </div>

  <div class="grid gap-4 sm:grid-cols-2">
    <ui-calculated-box
      label="Base Land Value"
      [value]="landValue()"
      derivation="Plot Area × Circled Land Rate"
    />
    <ui-calculated-box
      label="Asking Rate (₹/sq ft)"
      [value]="askingPsf()"
      derivation="Asking Price ÷ Plot Area"
    />
  </div>

  <ui-note-bar tone="info">
    @if (isHouse()) {
      Land is valued separately from the structure. The building component is
      captured on the next step.
    } @else {
      Compare the Asking Rate against the Circled Land Rate above.
    }
  </ui-note-bar>
</div>
